function LoadingView() {
    return (
        <div className={'layout vertical overlay'}>
            <span className={'fa-solid fa-loader'} style={{color: 'white'}}/>
        </div>
    )
}

export default LoadingView;